import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=1c381019&"
import script from "./Pagination.vue?vue&type=script&lang=js&"
export * from "./Pagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/fared/kowamas-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c381019')) {
      api.createRecord('1c381019', component.options)
    } else {
      api.reload('1c381019', component.options)
    }
    module.hot.accept("./Pagination.vue?vue&type=template&id=1c381019&", function () {
      api.rerender('1c381019', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/widgets/ui/Pagination.vue"
export default component.exports